export default __webpack_public_path__ + "static/media/search-icon.a1b1c4e6.svg";